import React, { useState, useEffect, useRef } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CButton,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CProgress,
} from "@coreui/react";
import { fetchAuthSession } from "aws-amplify/auth";
import AWS from '../../aws-mock';
import { useNavigate } from "react-router-dom"; // Para redirigir después de la subida

function multipart() {
  const S3_BUCKET = "www.codeflex.lat";
  const DYNAMODB_TABLE_NAME = "codeflex";
  const REGION = "us-east-1";
  const LIMIT_NON_PREMIUM = 7 * 1024 * 1024 * 1024; // 7 GB límite para no premium
  const LIMIT_PREMIUM = 300 * 1024 * 1024 * 1024; // 300 GB límite para premium
  const LIMIT_ESTUDIANTE = 14 * 1024 * 1024 * 1024; // 14 GB límite para estudiante

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESSKEYID,
    secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
  });

  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
    }),
  });

  const myBucket = new AWS.S3({
    apiVersion: "2006-03-01",
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const [sub, setUser] = useState();
  const [base, setDB] = useState(); // Si el usuario es premium o no
  const [totalSize, setTotalSize] = useState(0);
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0); // Estado para el progreso de la subida
  const [isUploading, setIsUploading] = useState(false); // Estado para controlar si hay una subida en proceso
  const [remainingTime, setRemainingTime] = useState("Calculando...");
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const [carpeta, setCarpeta] = useState(""); // Estado para manejar el nombre de la carpeta
  const [email, setEmail] = useState()

  const russianDomains = [
    "msu.ru", 
    "spbu.ru", 
    "misis.ru", 
    "mipt.ru", 
    "hse.ru", 
    "spbstu.ru", 
    "kpfu.ru", 
    "nsu.ru"
  ];

  const isRussianEmail = (email) => {
    return russianDomains.some(domain => email.endsWith(domain));
  };

  const navigate = useNavigate(); // Para redirigir después de la subida

  const abortControllerRef = useRef(null); // Referencia para manejar el AbortController

  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then((data) => {
          leerptoyectos(data.tokens.accessToken.payload.username);
          loadLEGALES2(data.tokens.accessToken.payload.sub);
          setUser(data.tokens.accessToken.payload.sub);
          setEmail(data.tokens.idToken.payload.email);
        });
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  async function leerptoyectos(sub) {
    const params = {
      TableName: DYNAMODB_TABLE_NAME,
      Key: {
        token: sub,
      },
    };
    try {
      const data = await dynamodb.get(params).promise();
      if (data.Item) {
        let validado = data.Item.premium;
        setDB(validado); // Guardar si es premium o no
      } else {
        console.log("Usuario no encontrado.");
      }
    } catch (err) {
      console.error("Error al buscar usuario:", err);
    }
  }

  async function loadLEGALES2(sub) {
    const params = {
      Bucket: S3_BUCKET,
      Prefix: "documentos/" + sub + "/",
    };
    const data = await myBucket.listObjectsV2(params).promise();
    let sumSize = 0;

    for (const obj of data.Contents) {
      sumSize += obj.Size;
    }
    setTotalSize(sumSize);
  }

  function formatBytes(bytes) {
    if (bytes === 0) return "0 Bytes";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  }

  // Función para manejar la subida de archivos con soporte de cancelación
  async function handleUpload(file) {
    const name = file.name;
    const fileSize = file.size; // Tamaño del archivo en bytes

    const esCorreoEducativo = email.endsWith('.edu') ||  
        email.endsWith('.una.ac.cr')|| // Costa rica UNA
        email.endsWith('.edu.co') || // Colombia
        email.endsWith('.edu.ar') || // Argentina
        email.endsWith('.edu.mx') || // México
        email.endsWith('.edu.es') || // España
        email.endsWith('.edu.ve') || // Venezuela
        isRussianEmail(email) || // Rusia
        email.endsWith('.edu.br'); // Brasil
    

    // Verificar si el usuario es estudiante
    if (esCorreoEducativo && totalSize + fileSize > LIMIT_ESTUDIANTE) {
      alert("Espacio insuficiente para subir este archivo.");
      return;
    }

    // Verificar si el usuario es premium
    if (base && totalSize + fileSize > LIMIT_PREMIUM) {
      alert("Espacio insuficiente para subir este archivo.");
      return;
    }

    // Verificar espacio disponible solo si el usuario no es premium
    if (!base && totalSize + fileSize > LIMIT_NON_PREMIUM) {
      alert("Espacio insuficiente para subir este archivo.");
      return;
    } 


    let carpetaLimpia = carpeta.replace(/\/$/, "");

    // Iniciar la subida
    setIsUploading(true);

    // Crear un nuevo AbortController
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      ContentType: file.type,
      Key: "documentos/" + sub + "/" + (carpetaLimpia ? carpetaLimpia + "/" : "") + name, // Guardar en la carpeta del usuario
    };

    const startTime = Date.now(); // Guardar el tiempo de inicio para estimar el tiempo restante

    const upload = myBucket.upload(params);

    upload.on("httpUploadProgress", (progress) => {
      setUploadProgress(Math.round((progress.loaded / progress.total) * 100)); // Actualizar progreso

      // Calcular el tiempo estimado restante
      const elapsedTime = (Date.now() - startTime) / 1000; // tiempo en segundos
      const uploadSpeed = progress.loaded / elapsedTime; // bytes por segundo
      const remainingBytes = progress.total - progress.loaded;
      const estimatedTime = remainingBytes / uploadSpeed; // tiempo estimado restante en segundos
      setRemainingTime(`${Math.round(estimatedTime)}s`); // Actualizar el tiempo restante
    });

    try {
      await upload.promise();
      if (!abortControllerRef.current.signal.aborted) {
        // Verificar si no ha sido cancelado
        alert("Archivo subido correctamente.");
        // Actualizar el espacio disponible después de la subida
        loadLEGALES2(sub);
        navigate("index.html"); // Redirigir después de la subida exitosa
      }
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Subida cancelada.");
      } else {
        console.error("Error al subir el archivo:", err);
        alert("Error al subir el archivo.");
      }
    } finally {
      setIsUploading(false); // Reiniciar el estado de subida
    }
  }

  // Función para cancelar la subida
  function cancelUpload() {
    if (isUploading && abortControllerRef.current) {
      abortControllerRef.current.abort(); // Cancelar la subida
      setIsUploading(false);
      setUploadProgress(0); // Reiniciar el progreso
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>
        {base ? ( // Si es usuario premium
          <CCol xs={12}>
            <CCard className="mb-4 ccard-custom-style">
              <CCardHeader>
                <strong className="text-primary">¡Bienvenidos a Multipart</strong>
              </CCardHeader>
              <CCardBody style={{ textAlign: "center", paddingBottom: "40px" }}>

                {email.endsWith('.edu') ||  email.endsWith('.una.ac.cr') ||  email.endsWith('.edu.co') ||  isRussianEmail(email) || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve') ?
                  <>
                    <p>Usuario institucional: El tamaño máximo total es de 14 GB.</p>
                    <p>Espacio usado: {formatBytes(totalSize)} / 14 GB</p>
                  </>
                :
                  <>
                    <p>Usuario premium: El tamaño máximo total es de 300 GB.</p>
                    <p>Espacio usado: {formatBytes(totalSize)} / 300 GB</p>
                  </>
                }

                <div style={{ marginTop: "20px" }}>
                  <input
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                    style={{
                      marginRight: "15px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      padding: "10px",
                      cursor: "pointer",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Nombre de la carpeta (No terminar en /)"
                    value={carpeta}
                    onChange={(e) => setCarpeta(e.target.value)} // Permitir al usuario escribir cualquier cosa, incluyendo '/'
                    style={{
                      marginTop: "10px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      width: "280px",
                      padding: "10px",
                    }}
                  />
                  <br />
                  <br />
                  <strong>
                    <p>{`s3:// ${carpeta ? carpeta + "/" : ""}${file ? file.name : ""}`}</p>
                  </strong>
                  {file && (
                    <CButton
                      onClick={() => handleUpload(file)}
                      disabled={!file || isUploading}
                      style={{
                        backgroundColor: "#5e72e4",
                        color: "#fff",
                        padding: "10px 20px",
                        borderRadius: "8px",
                      }}
                    >
                      Subir archivo
                    </CButton>
                  )}
                </div>
              </CCardBody>
            </CCard>
          </CCol> 
        ) : (
          // Si es usuario no premium
          <CCol xs={12}>
            <CCard className="mb-4 ccard-custom-style">
              <CCardHeader>
                <strong className="text-primary">¡Bienvenidos a Multipart</strong>
              </CCardHeader>
              <CCardBody style={{ textAlign: "center", paddingBottom: "40px" }}>
                <p>Usuarios no premium: El tamaño máximo total es de 7 GB.</p>
                <p>Espacio usado: {formatBytes(totalSize)} / 7 GB</p>
                <div style={{ marginTop: "20px" }}>
                  <input
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                    style={{
                      marginRight: "15px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      padding: "10px",
                      cursor: "pointer",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Nombre de la carpeta (No terminar en /)"
                    value={carpeta}
                    onChange={(e) => setCarpeta(e.target.value)} // Permitir al usuario escribir cualquier cosa, incluyendo '/'
                    style={{
                      marginTop: "10px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      width: "280px",
                      padding: "10px",
                    }}
                  />
                  <br />
                  <br />
                  <strong>
                    <p>{`s3:// ${carpeta ? carpeta + "/" : ""}${file ? file.name : ""}`}</p>
                  </strong>
                  {file && (
                    <CButton
                      onClick={() => handleUpload(file)}
                      disabled={!file || isUploading}
                      style={{
                        backgroundColor: "#5e72e4",
                        color: "#fff",
                        padding: "10px 20px",
                        borderRadius: "8px",
                      }}
                    >
                      Subir archivo
                    </CButton>
                  )}
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        )}

        {isUploading && (
          <CCol xs={12} style={{ marginTop: "30px" }}>
            <CCard className="mb-4 ccard-custom-style">
              <CCardBody style={{ padding: "20px" }}>
                <CTable
                  responsive
                  hover
                  bordered
                  className="custom-table"
                  style={{ marginBottom: 0 }}
                >
                  <CTableHead
                    style={{ backgroundColor: "#f7f7f7", borderBottom: "2px solid #dee2e6" }}
                  >
                    <CTableRow>
                      <CTableHeaderCell>Nombre</CTableHeaderCell>
                      <CTableHeaderCell>Progreso</CTableHeaderCell>
                      <CTableHeaderCell>Porcentaje</CTableHeaderCell>
                      <CTableHeaderCell>Tiempo restante estimado</CTableHeaderCell>
                      <CTableHeaderCell>Cancelar</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    <CTableRow>
                      <CTableDataCell>{file.name}</CTableDataCell>
                      <CTableDataCell>
                        <CProgress value={uploadProgress} />
                      </CTableDataCell>
                      <CTableDataCell>{uploadProgress}%</CTableDataCell>
                      <CTableDataCell>{remainingTime}</CTableDataCell>
                      <CTableDataCell>
                        <CButton
                          onClick={cancelUpload}
                          color="danger"
                          style={{ padding: "5px 15px" }}
                        >
                          Cancelar
                        </CButton>
                      </CTableDataCell>
                    </CTableRow>
                  </CTableBody>
                </CTable>
              </CCardBody>
            </CCard>
          </CCol>
        )}
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default multipart;
